<!--
 * @Author: your name
 * @Date: 2021-12-29 12:21:16
 * @LastEditTime: 2022-12-29 19:29:15
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page2-wrapper">
        <!-- <div class="page2-content animate__animated animate__fadeIn"> -->
            <!-- <div class="page-title">创作达人</div> -->
            <!-- <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-46Ks7AEY0zFDVLZrb.png" class="start-icon animate__animated  animate__pulse">
           <div class="title">
             <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-46XxA7L0IrOCclqQD.png" class="title-img animate__animated animate__fadeInDownBig"/>
           </div> -->
            <div class="page2-content animate__animated animate__fadeInDownBig" v-if="reportData.postNum || reportData.chatNum">
                    <!-- 这一年<br>
                    你一共创作了<span class="report-num"> {{ reportData.postNum }} </span>篇内容<br>
                    获得<span class="report-num"> {{ reportData.readedNum }} </span>阅读量<br>            
                    <span  v-if="times.times > 1">相当于被京东所有产研传阅了<span class="report-num"> {{ times.times }} </span>遍<br></span>
                    <span v-else>相当于被京东<span class="report-num"> {{ times.percent }}% </span>的产研传阅了1遍</span><br>
                    最优秀的一篇文章<br>
                    <span class="report-num">《{{ reportData.maxViewPost }}》</span><br>
                    有<span class="report-num"> {{ reportData.maxViewPostNum }} </span>人浏览<br>
                    感谢你的创作和分享<br>
                    星星之火，足以燎原 -->
                    这一年你在神灯发表了<br>
                    <template v-if="reportData.postNum"><span class="report-num"> {{ reportData.postNum }} </span>篇文章<br></template>
                    <template v-if="reportData.chatNum"><span class="report-num"> {{ reportData.chatNum }} </span>个畅聊<br></template>
                    <span class="sum-up">
                        这并不是一串简单的数字<br>
                        而是你对技术热爱的厚度
                    </span>
            </div>
            <div class="page2-content page2-content-empty animate__animated animate__fadeInDownBig" v-else>
                虽然这一年<br>
                你没有在神灯发布过内容<br>
                但人人都知道你是一个潜力股～<br>
                2023年社区<br>
                沉淀文章<span class="report-num"> {{ reportData.community.totalPostNum }} </span>篇<br>
                汇集畅聊<span class="report-num"> {{ reportData.community.totalPostNum }} </span>个<br>
                <!-- <span class="report-num"> {{ reportData.community.totalRefineNum }} </span>篇被评为精品文章<br> -->
                <!-- <span class="report-num"> 58 </span>篇通过神灯发布到外网<br> -->
                为产研建立丰富的知识库<br>
                <!-- 汇聚着每一个京东技术人的星星之火<br> -->
            </div>
            <!-- <div class="sprite"></div>
            <div class="sprite"></div> -->
        <!-- </div> -->
    </div>
</template>

<script>
export default {
    name: 'Page2',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    computed: {
        firstTime() {
            if (this.reportData.firstPostTime) {
                const [s1, time] = this.reportData.firstPostTime.split(' ');
                const [year, month, date] = s1.split('-');
                const [hour, minute, second] = time.split(':');
                return {
                    year,
                    month,
                    date,
                    time,
                    hour,
                    minute,
                    second
                };
            } else {
                return {
                    year: '',
                    month: '',
                    date: '',
                    time: '',
                    hour: '',
                    minute: ''
                };
            }
        },
        times() {
            const multiple = (this.reportData.readedNum / 20000).toFixed(2);
            return multiple > 1 ? { times: multiple } : { times: 0, percent: multiple * 100 }
        }
    },
    methods: {
        handleNext() {
            this.$emit('next');
        },
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page2-wrapper {
    height: 100vh;
    width: 100%;
    // padding: 0 20px;
    background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-15-49KjOW7fHpe68rAJ9.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    .start-icon {
        position: absolute;
        top: 5vh;
        right: 16px;
        width: 1.5rem;
        height: 1.5rem;
    }
    .page2-content {
        margin: 3.5rem auto 0;
        // padding: 6vh 36px;
        font-size: 0.4rem;
        font-weight: bold;
        line-height: 2.8;
        color: #FAFAD7;
        box-sizing: border-box;
        // text-shadow: 1px 1px #19139B;
        // background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-15-20128ZSRU25gTIExp3K.png');
        background-size: 100% 100%;
    }
    .page2-content-empty {
        padding-top: 5vh;
    }
    .page-title {
        width: 100px;
        color: #fff;
        background: #2D97E1;
        border-radius: 4px;
        margin-bottom: 40px;
        font-weight: 500;
        line-height: 1;
        padding: 6px 0;
        position: relative;
        &:after {
            position: absolute;
            display: block;
            content: '';
            width: 300px;
            height: 4px;
            bottom: -4px;
            border-radius: 4px;
            background: #D9F0F9;
        }
    }
    .title-img {
        // height: 1.3rem;
        width: 70%;
        text-align: left;
    }
    .sprite {
        width: 1.25rem;
        height: 1.36rem;
        background-repeat: no-repeat;
        background-image: url(https://storage.360buyimg.com/iast-agent/reportSprite1.png);
        background-size: 1.34rem 2.54rem;
        -webkit-transform-origin: 0.08rem 100%;
        -webkit-animation: paddy 1s infinite ease-in-out alternate
    }
    @keyframes paddy {
        0% {
            -webkit-transform: rotate(20deg);
        }
        100% {
            -webkit-transform: rotate(-20deg);
        }
    }
    .report-num {
        color: #f1f406;
        font-weight: 600;
        font-size: 0.55rem;
    }
    .title {
        text-align: left;
        padding-left: 1rem;
        padding-top: 5vh;
    }
}
 @media screen and (min-width: 1980px) {
  #page2-wrapper {
    .page2-content {
        margin-top: 28vh;
    }
  }
}
</style>
